import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

// Idiomas soportados: añade aquí el código al agregar uno nuevo en translations.js
const SUPPORTED_LANGS = ["en", "es", "pl", "it", "fr", "pt", "uk", "ro", "zh", "hi"];
const DEFAULT_LANG = "en"; // negocio en Reino Unido: inglés por defecto

// El idioma vive en la URL: ?lang=xx (SEO / hreflang). Sin parámetro → inglés siempre.
const detectLang = () => {
  const fromUrl = new URLSearchParams(window.location.search).get("lang");
  return fromUrl && SUPPORTED_LANGS.includes(fromUrl) ? fromUrl : DEFAULT_LANG;
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(detectLang);

  useEffect(() => {
    const url = new URL(window.location.href);
    if (lang === DEFAULT_LANG) url.searchParams.delete("lang");
    else url.searchParams.set("lang", lang);
    window.history.replaceState(null, "", url);
  }, [lang]);

  const t = translations[lang] || translations[DEFAULT_LANG];

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
